export interface Role {
  id: string;
  name: 'admin' | 'manager' | 'chef' | 'staff' | 'viewer';
  displayName: string;
  description: string;
  permissions: string[];
  color: string;
}

export const roles: Role[] = [
  {
    id: '1',
    name: 'admin',
    displayName: 'Administrator',
    description: 'Full access to all features and settings',
    permissions: [
      'dashboard',
      'orders',
      'view_order_details',
      'menus',
      'tables',
      'customers',
      'reviews',
      'analytics',
      'reports',
      'settings',
      'users',
      'roles'
    ],
    color: 'indigo'
  },
  {
    id: '2',
    name: 'manager',
    displayName: 'Manager',
    description: 'Access to operations and customer management',
    permissions: [
      'dashboard',
      'orders',
      'view_order_details',
      'menus',
      'tables',
      'customers',
      'reviews',
      'analytics',
      'reports'
    ],
    color: 'blue'
  },
  {
    id: '3',
    name: 'chef',
    displayName: 'Chef',
    description: 'Access to order details and kitchen management',
    permissions: [
      'dashboard',
      'orders',
      'view_order_details',
      'menus',
      'tables'
    ],
    color: 'orange'
  },
  {
    id: '4',
    name: 'staff',
    displayName: 'Staff',
    description: 'Access to orders and basic operations',
    permissions: [
      'dashboard',
      'orders',
      'view_order_details',
      'menus'
    ],
    color: 'green'
  },
  {
    id: '5',
    name: 'viewer',
    displayName: 'Viewer',
    description: 'Read-only access to dashboard and analytics',
    permissions: [
      'dashboard',
      'analytics'
    ],
    color: 'gray'
  }
];

export function getRolePermissions(roleName: string): string[] {
  const role = roles.find(r => r.name === roleName.toLowerCase());
  return role ? role.permissions : [];
}

export function hasPermission(roleName: string, permission: string): boolean {
  const permissions = getRolePermissions(roleName.toLowerCase());
  return permissions.includes(permission);
}